import Navigator from "../../component/navigator";
import styles from "./index.module.scss";
import Cover from "./components/cover";
import useCourseOverview from "../../hooks/use-course-overview";
import Group from "./components/group";
import { useParams } from "react-router-dom";
import RankList from "../challenges/components/rank-list";
import ReactMarkdown from "react-markdown";
import Progress from "./components/progress";
import ChallengePlan from "./components/challenge-plan";
import useChallengePlans from "../../hooks/use-challenge-plans";

const ChallengesGroup = () => {
  const { courseNo } = useParams<{ courseNo: string }>();
  const { overview, refresh } = useCourseOverview(courseNo);
  const relevantPlans = useChallengePlans(courseNo);

  return (
    <>
      <Navigator activeKey="problemset" />
      <div className={styles.challengesGroup}>
        <div className={styles.hero}>
          <div className={styles.content}>
            <Cover src={overview?.courseIcon || ""} />
            <div className={styles.infos}>
              <div className={styles.title}>{overview?.title}</div>
              <Progress
                current={overview?.progress?.learnCoachNumber || 0}
                total={overview?.progress?.totalCoachNumber || 0}
                className={styles.progress}
              />
            </div>
          </div>
        </div>
        <div className={styles.main}>
          <div className={styles.groups}>
            {overview?.categories?.map((category) => (
              <Group category={category} key={category.id} onUpdate={refresh} />
            ))}
          </div>
          <div className={styles.extra}>
            <div className={styles.section} style={{ marginBottom: 12 }}>
              <div className={styles.header}>
                <div className={styles.title}>概览</div>
              </div>
              <div className={styles.body}>
                <ReactMarkdown>{overview?.summary || ""}</ReactMarkdown>
              </div>
            </div>
            <div className={styles.section} style={{ marginBottom: 12 }}>
              <div className={styles.header}>
                <div className={styles.title}>相关计划</div>
              </div>
              <div className={styles.body}>
                {relevantPlans.map((plan: Record<string, any>) => (
                  <ChallengePlan
                    key={plan.id}
                    cover={plan.mini_cover_img}
                    title={plan.title}
                    description={plan.brief_summary}
                    courseNo={plan.course_no}
                    className={styles.relevantPlan}
                  />
                ))}
              </div>
            </div>
            <RankList title="七日十佳" type="week" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChallengesGroup;
